export const odluka_inventura = {
  templateId: 208,
  category: 4,
  templateTitle: 'Odluku o provođenju godišnjeg popisa imovine i obveza te imenovanju komisije za popis',
  templateDescription: `<p>Inventura predstavlja godišnji popis imovine i obveza te je zakonska obveza poduzetnika, a ujedno pruža i važne informacije o financijskom položaju poduzetnika, no može otkriti i eventualne propuste ili prijevare.</p>`,
  description: `
  <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
  <p>Popis imovine i obveza trgovačkog društva provodi se sa ciljem usklađivanja knjigovodstvenog stanja ("koliko čega treba biti”) sa stvarnim stanjem (“koliko čega ima”), a isti je i obveza prema Zakonu o računovodstvu i Općem poreznom zakonu.</p>
  <p>Osim zakonske obveze, uredno i kvalitetno provođenje inventure treba predstavljati i interes poduzetnika jer nekvalitetna inventura ili njezino neprovođenje omogućuju prikrivanje krađa, prijevara, skrivanje gubitaka i sl. pa mogu rezultirati nerealnim financijskim izvještajima i neispravnim poreznim obračunima.</p>
  <p>Popisom se obavlja provjera fizičkog postojanja i korisnost (uporabljivost) imovine. Bez popisa se ne može pouzdano znati da li sva imovina koja je zapisana u poslovnim knjigama doista i postoji, da li je u funkciji odnosno kolika joj je vrijednost. </p> 

  <p>Provođenje redovitog godišnjeg popisa obavlja komisija/e za popis i to: brojanjem, vaganjem, mjerenjem i drugim postupcima utvrđuju stvarno stanje imovine.</p>
  <p>Takvo stanje komisija unosi u popisne liste.</p>
  <p>Zakon o računovodstvu određuje da je provođenje popisa obveza poduzetnika, a poduzetnike definira kao:  </p>
  <li> trgovačko društvo i trgovac pojedinac određeni propisima kojima se uređuju trgovačka društva, </li>
  <li> poslovnu jedinica navedenog poduzetnika sa sjedištem u drugoj državi članici ili trećoj državi ako prema propisima te države ne postoji obveza vođenja poslovnih knjiga i sastavljanja financijskih izvještaja, te poslovna jedinica poduzetnika iz države članice ili treće države koji su obveznici poreza na dobit sukladno propisima kojima se uređuju porezi,</li>
  <li> podružnicu inozemnih poduzetnika u Republici Hrvatskoj, ako ista nije poslovna jedinica, kako je određeno propisima kojima se uređuju trgovačka društva.</li>
  <br> 

  <p>Osim poduzetnika, odredbe koje se odnose na popis imovine i obveza dužna je primjenjivati i svaka pravna i fizička osoba (čak iako je udruga i njihov savez, zaklada, fundacija, ustanova, umjetnička organizacija, komora, sindikat, udruge poslodavaca, i svaka druge pravne osobe kojima temeljna svrha osnivanja i djelovanja nije stjecanje dobiti, za koje iz posebnih propisa proizlazi da su neprofitnog karaktera, koje financijsko poslovanje i računovodstvo vode sukladno zakonu kojim se uređuje financijsko poslovanje i računovodstvo neprofitnih organizacija ili na drugi način prema posebnim propisima) koja je obveznik poreza na dobit određena propisima kojima se uređuju porezi.</p>
  <p>Popis razlikujemo s obzirom na:  </p>
  <ul> 1. Vrijeme obavljanja popisa </ul>
  <li> redovni,</li>
  <li> izvanredni.</li>
  <br>
  <ul> 2. Obuhvat </ul>
  <li> potpuni,</li>
  <li> djelomični,</li>
  <li> kontinuirani</li>
  <br>
  <p>Redoviti potpuni popis imovine i obveza provodi se na početku poslovanja te na kraju svake poslovne godine (takav popis je ustvari sinonim za inventuru).  </p>
  <p>Izvanredni potpuni popis provodi se kod statusnih promjena (podjela, spajanje, pripajanje trgovačkih društava) odnosno kod likvidacije i stečaja te u drugim izvanrednim slučajevima.</p>
  <p>Izvanredni djelomični popis imovine i obveza provodi se i prilikom primopredaje dužnosti (računopolagatelja, blagajnika, skladištara  itd.) ili kod  promjene cijena određenim artiklima ili promjene poreznih stopa.</p>
  <p>Ipak, redovni potpuni popis (inventura) će se teško provesti u danima kad određene djelatnosti ostvaruju najveći promet (trgovina, ugostiteljstvo i sl.), stoga se neće provesti 31.12., nego se  provodi u prvim danima iduće kalendarske godine. </p>
  <p><strong>Predmet inventure su ukupna imovina i obveze, odnosno ukupna aktiva i obveze, što znači da popisati treba dugotrajnu nematerijalnu imovinu, dugotrajnu materijalnu imovinu, dugotrajnu i kratkotrajnu financijsku imovinu, dugotrajna i kratkotrajna potraživanja, zalihe, novac na računima u banci i u blagajni te dugoročne i kratkoročne obveze. </strong></p>
  <p>Imovina koja ima najmanji koeficijent obrtaja (dugotrajna imovina) se popisuje prva, dok se potom popisuje imovina koja ima najveći koeficijent obrtaja.  </p>
  <p>Posljednja se popisuju potraživanja od kupaca i obveze prema dobavljačima, a iz razloga što je nužno prethodno proknjižiti takve dokumente.</p>
  <p>U slučaju promjene cijena dobara, popis imovine nije nužan, ako se knjigovodstvenim evidencijama mogu osigurati podaci o vrijednosti robe na zalihi.</p>
  <p>Kako bi se popis što točnije proveo, nužno je postaviti određena pravila provođenja popisa, imenovati komisiju za popis, odrediti vrijeme popisa i rok za dostavu popisnih lista.  </p>
  <p>Popisne liste smatraju se knjigovodstvenim ispravama. </p>
  <p>Pripremne radnje koje poduzetnik treba obaviti prije popisa su sljedeće:</p>
  <li> imenovati komisiju,</li>
  <li> ažurirati i uskladiti evidencije,</li>
  <li> pripremiti za popis popisna mjesta,</li>
  <li> pripremiti popisni materijal,</li>
  <li> izraditi upute o obavljanju popisa,</li>
  <li> sastaviti plan popisivanja.</li>
  <br> 
  <p>Uobičajeno je da se u komisiju imenuje najmanje predsjednik i dva člana. Prijedlog je da se u komisiju ne imenuju zaposlenici koji su zaduženi za sredstva koja se popisuju niti njihovi neposredni rukovoditelji, kao ni osobe koje vode knjigovodstvo imovine ili obveza koji se popisuju.</p>
  <p>Odluka u nastavku može se donijeti kao odluka centralne komisije koja obavlja cjelokupni popis ili se može donijeti više odluka kojima će se odrediti obavljanje popisa pojedinih predmeta popisa.  </p>
  <p>Nakon obavljene inventure, prikupljaju se podaci o knjigovodstvenom stanju te se isti podaci obrađuju da bi se potom evidentirale inventurne razlike. Kao inventurne razlike mogu se pojaviti: viškovi i manjkovi.</p>
  <p>U knjigovodstvenom smislu, prema Uputi ministarstva financija obavezno je usklađenje potraživanja i obveza s vjerovnicima i dužnicima sa stanjem na dan 31. prosinca kalendarske godine.</p>
  <p>Kako se knjiženje istog završava u razdoblju 20.01.-31.01. knjigovodstvo ima obvezu dostaviti IOS-e u najkraćem mogućem roku na ovjeru svim vjerovnicima i obveznicima na usklađenje knjigovodstvenog stanja. U slučaju da poduzetnik ima dugoročne ili kratkoročne obveze prema financijskim institucijama ili leasing kuća, ovlaštene osobe moraju zatražiti od istih IOS (Izvod otvorenih stavaka) s prikazom stanja obveza na dan 31.12. te isti dostaviti u najkraćem mogućem roku u knjigovodstvo.</p>
  <p>Rok za dostavu ovjerenih IOS-a je 28/29.02., nakon čega će knjigovodstvo dostaviti izvještaj o utvrđenom i usklađenom stanju.</p>
  <p>Posebno napominjemo da svi izvještaji o popisu materijalne imovine moraju biti završeni do 20. siječnja,   s obzirom na rok za podnošenje zadnjeg obrasca PDV-a.  </p>
  <p>Nakon provedenog popisa imovine i obveza,  komisija za popis sastavlja pripadajući <a class="local-link" href="/contract?template=209">Izvještaj o popisu</a>. Svako odstupanje od popisa utvrđeno u Izvještaju potrebno je provesti u računovodstvu u skladu s knjigovodstvenim standardima te se u tom smislu mogu donijeti Odluke o knjiženju inventurnih razlika.</p>

  <h5>NAJČEŠĆE GREŠKE</h5>
  <p><strong>- Neobavljanje godišnjeg popisa - prekršaj</strong></p>
  <p>Pojašnjenje: sukladno članku 32. Zakona o računovodstvu, predviđena je novčana kazna za poduzetnika od 10.000,00 do 100.000,00 kn te za odgovornu osobu 5.000,00 do 20.000,00 kn. </p>
  <h5><strong>PRAVNA OSNOVA</strong></h5>
  <p>Zakon o računovodstvu, Opći porezni zakon.</p>

  `,
  sides: [
      {
          prefix: 'Na temelju odredbi Zakona o računovodstvu i Općeg poreznog zakona,',
          signature: 'Za Poduzetnika:',
          inputs: [{
              type: "input",
              required: true,
              placeholder: "Poslovni subjekt",
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija",
              inSignature: true,
            }],
      }
  ],

  headline: '​donosi sljedeću',
  title: 'ODLUKA O PROVOĐENJU GODIŠNJEG POPISA IMOVINE I OBVEZA TE IMENOVANJU KOMISIJE ZA POPIS',
  noArticleNumbers: true,

  articles: [
    {
      title: '',
      mandatory: true,
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'U svrhu usklađenja knjigovodstvenog i stvarnog stanja imovine i obveza, nalaže se Komisiji iz ove Odluke provođenje pripremnih radnji te provođenje popisa imovine i obveza u skladu s ovom Odlukom.',
              value: '',
          },
      ],
      value: '',
  },
    {
      title: '',
      mandatory: false,
      examplecontent:true, 
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'Za popis imovine i obveza navedenih u ovoj Odluci, imenuje se komisija za popis u sljedećem sastavu: \r\n- ___________________________, predsjednik komisije, \r\n- ___________________________, član komisije, \r\n- ___________________________, član komisije.',
              value: '',
          },
      ],
      value: '',
  }, 
  {
    title: '',
    mandatory: false,
    examplecontent:true, 
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'U okviru popisa imovine i obveza, komisija je dužna izraditi: \r\n- popis dugotrajne imovine (nematerijalna imovina, materijalna imovina, financijska imovina, dugotrajna potraživanja i odgođena porezna imovina),  \r\n- popis zaliha (vlastita i trgovačka roba), \r\n- popis sitnog inventara,  \r\n- popis potraživanja - od kupaca, od radnika, od članova društva te danih zajmova, danih predujmova, danih garancija, danih jamčevina, \r\n- popis novčanih sredstava - sredstva na žiro računima, sredstva u blagajnama, \r\n- popis obveza (dugoročnih i kratkoročnih) - prema dobavljačima, prema radnicima, prema poreznoj upravi, prema kreditnim institucijama (dugoročni i kratkoročni zajmovi) i obveze za leasing (operativni ili financijski). ',
            help: 'U slučaju da se ovlaštena osoba za zastupanje želi posao izrade popisa razdijeliti na više komisija, svakoj se posebno određuje obuhvat izrade popisa te može biti i manji od ovdje navedenog. ',
            value: '',
        },
    ],
    value: '',
}, 
{
  title: '',
  mandatory: true,
  statements: [
      {
          type: 'choice',
          mandatory: true,
          editable: true,
          choices: [
              'Komisija će obaviti popis imovine i obveza navedenih u ovoj Odluci, dok će popis ostale imovine i obveza obaviti druge komisije, a o čemu će Poduzetnik donijeti odluku odnosno posebne odluke.',
              'Komisija iz ove Odluke imenuje se kao jedina komisija koja će obaviti popis sve imovine i svih obveza navedenih u ovoj Odluci. ',
            ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
          help: 'U slučaju pdabora Opc. 1. donosi se više odluka - za svaki popis imovine i obveza posebno.',

      }
  ]
},
{
title: '',
mandatory: false,
examplecontent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Zadaci komisije su: \r\n- utvrditi stvarno stanje i količinu predmeta popisa - ispravno, oštećeno, nekurentno, neuporabljivo i sl., \r\n- unijeti podatke o stvarnom stanju u popisne liste i vrijednosno ih iskazati,  \r\n- od knjigovodstva ishoditi podatke o knjigovodstvenom stanju,  \r\n- utvrditi viškove i manjkove,  \r\n- sastaviti Izvještaj o obavljenom popisu i dostaviti ga odgovornoj osobi,  \r\n- potpisati popisne liste koje su izradili te preuzeti odgovornost za njihovu točnost.',
        value: '',
    },
],
value: '',
}, 
{
  title: '',
  mandatory: false,
  examplecontent:true, 
  statements: [
    {
      type: 'text',
      required: true,
      mandatory: true,
      editable: true,
      content: 'Komisija ima obvezu obaviti sve potrebne pripremne radnje te obaviti popis u vremenu od ___________ do ___________ godine te utvrditi popis imovine i obveza na dan _____ godine.',
      value: '',
  },
    ],
},
{
title: '',
mandatory: false,
examplecontent:true, 
statements: [
  {
    type: 'text',
    required: true,
    mandatory: true,
    editable: true,
    content: 'Nakon obavljanja svih poslova vezanih uz popis te ishođenja iz knjigovodstva podataka o knjigovodstvenom stanju te unosa podataka u popisne liste odnosno utvrđenja inventurnih viškova/manjkova, Komisija će  izraditi Izvještaj o izvršenom popisu te dostaviti isti odgovornoj osobi Poduzetnika najkasnije do ____  iduće godine.',
    value: '',
},
  ],
},
    {
      title: '',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'Ova Odluka primjenjuje se od trenutka potpisa.',
              value: '',
          },
      ],
      value: '',
  }, 

  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signature
    statements: [],
  },
  {
    static: true,
    mandatory: false,
    type: 4, 
    statements: [
      {
        type: 'text',
        mandatory: true,
        editable: true,
        content: 'Dostaviti:\r\n1) Članovima inv. komisije \r\n2) Kadrovska evidencija ',
        help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
      }
    ]
  },
],
};








// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/208_odluka_inventura.ts